import React from 'react' // eslint-disable-line no-unused-vars
import via2 from './assets/VIA2.png'
import amiImgLandingMobile from './assets/ami_img_landing_mobile.png'
import amiRotateIconMobile from './assets/ami_rotate_icon_mobile.png'
import via5 from './assets/VIA5.png'
import { Link, Redirect } from 'react-router-dom'
import StaticConfig from '../StaticConfig.js'
import { ANALYTICS_LINK_SECTIONS, PERMISSIONS, PATIENT } from '../../constants'
import { API_BASE_URL } from '../../index'
import ListPagination from './ListPagination.js'
import { getPermittedOptions } from './BotAssistantUtils'

class ContentMobile extends React.Component {
  render () {
    if (this.props.selection && this.props.selection.deadend) {
      return <Deadend content={this.props.content.deadend} permissions={this.props.permissions} />
    }

    if (this.props.selection) {
      if (this.props.selection.content) {
        return <Answer {...this.props} />
      } else if (this.props.selection.name) {
        return this.ProductCategories(this.props) // return <ProductCategories {...this.props} />;
      } else if (this.props.selection.id || this.props.selection.categoryId) {
        return <Questions {...this.props} />
      }
    }

    if (
      this.props.selection &&
      this.props.selection.value &&
      this.props.content.link[this.props.selection.value]
    ) {
      return (
        <Answer
          {...this.props}
          selection={{
            content: {
              contentType: 'LINK',
              displayText: this.props.content.link[this.props.selection.value]
            }
          }}
        />
      )
    }

    if (this.props.selection && this.props.selection.value) {
      switch (this.props.selection.value) {
        case this.props.landingSelectionValue:
          return this.Landing({ ...this.props, showFeedbackLink: this.props.userType === PATIENT })
        case this.props.content.landing.options[0].value:
          return (
            <StaticSelection
              {...this.props}
              static={this.props.content.static.product}
            />
          )
        case this.props.content.landing.options[1].value:
          return (
            <StaticSelection
              {...this.props}
              static={this.props.content.static.clinical}
              showFeedbackLink={this.props.userType !== PATIENT}
            />
          )
        case this.props.content.landing.options[2].value:
          return (
            <ReportAdverseEvents
              selections={this.props.selections}
              onNav={this.props.onNav}
              promptContent={this.props.content.static}
              languageContent={this.props.patientContent}
            />
          )
        case this.props.content.landing.options[3].value:
          return (
            <AssistantRedirect
              prompt={this.props.content.static.stabilityPrompt}
              pathname={this.props.content.static.stabilityRedirect}
              stabilityPrompt
              closeAssistant
            />
          )
        case this.props.content.landing.options[4].value:
          return (
            <AssistantRedirect
              prompt={this.props.content.static.stabilityPromptPatient}
              pathname={this.props.content.static.stabilityRedirect}
              stabilityPrompt
              closeAssistant
            />
          )
        case this.props.content.landing.options[5].value:
          return (
            <StaticSelection
              {...this.props}
              static={this.props.content.static.disease}
            />
          )
        case this.props.content.landing.options[6].value:
       // case this.props.content.landing.options[this.props.content.landing.options.landingPos].value:
          return (
            <AssistantRedirect
              prompt={this.props.content.static.mslPrompt}
              pathname={this.props.content.static.mslRedirect}
              state={{
                fields: {
                  question: {
                    value: this.props.content.static.mslRedirectState
                  }
                }
              }}
              closeAssistant
            />
          )
        case this.props.content.static.product.options[4].value:
       // case this.props.content.static.product.options[this.props.content.static.product.prodspecinfpos].value:
          return <ProductSelection {...this.props} />
        case this.props.content.static.product.options[5].value:
          return (
            <AssistantRedirect
              prompt={this.props.content.static.productPrompt}
              pathname={this.props.content.static.productRedirect}
              state={{}}
            />
          )
        default:
      }
    }

    return <Error content={this.props.content.error} />
  }

  /* LANDING PAGE */
  Landing = props => {
    const updatedPermLandingOptions = [...props.permittedLandingOptions]
    const paginationMapItem = props.paginationMap.get(props.paginationMapKey)
    const pageNumber = paginationMapItem.pageNumber
    const pageSize = paginationMapItem.pageSize
    const totalPages = paginationMapItem.totalPages
    const optionsSlice = this.getPageRows(updatedPermLandingOptions, pageNumber, pageSize)
    const options = optionsSlice
      .map((option, index, arr) => {
        return option === 'filler_option'
          ? (
            <span
              className='one-col'
              key={index}
            >
              <div
                className='assistant-mobile-option'
                style={{ color: 'white' }}
              >
          -
              </div>
            </span>
          )
          : option.value !== 'feedback'
            && (
              <span
                className='one-col'
                key={index}
              >
                <div
                  className='assistant-mobile-option'
                  onClick={() => props.onClick(option)}
                  data-tag='track-link'
                  data-analytics-text={ANALYTICS_LINK_SECTIONS.ASSISTANT + option.value}
                >
                  {option.label}
                </div>
              </span>
            )
      })
    const isLandscape = document.documentElement.clientWidth > document.documentElement.clientHeight

    return (
      isLandscape
        ? (
          <div className='assistant-mobile-content'>
            <table style={{ marginTop: '60px', marginLeft: 'auto', marginRight: 'auto' }}>
              <tr>
                <td>
                  <img src={amiRotateIconMobile} alt='Rotate to portrait mode' />
                </td>
                <td style={{ paddingLeft: '10px' }}>Please rotate your device to portrait orientation
                  to utilize the digital assistant.
                </td>
              </tr>
            </table>
          </div>)
        : (
          <div className='assistant-mobile-content'>
            <div style={{ width: '100%', padding: '0px 0px 0px 0px', margin: 'auto' }}>
              <div style={{ position: 'relative' }}>
                <div className='landing-image' style={{ width: '25%' }}>
                  <img src={amiImgLandingMobile} alt='Ami' />
                </div>
                <div style={{
                  float: 'left',
                  width: '74%',
                  fontFamily: 'Open Sans',
                  fontSize: '14px',
                  lineHeight: '19px',
                  paddingBottom: '10px',
                  border: '0px solid red'
                }}
                >
                  <b>{props.content.landing.mobileConfirmation}</b>
                  {props.content.landing.mobileIntro}
                </div>
              </div>
              <hr />
            </div>
            <div style={{ clear: 'both', paddingTop: '8px' }}>
              <div
                style={{ fontFamily: 'Open Sans' }}
                className='assistant-mobile-prompt'
              >{props.content.landing.prompt}
              </div>
              <div className='assistant-mobile-options'>{options}
              </div>
              <ListPagination
                pageNumber={pageNumber}
                pageSize={pageSize}
                totalPages={totalPages}
                setPageNumber={this.props.setPaginationMapItemPageNumber}
                paginationMapKey={this.props.paginationMapKey}
              />
            </div>
          </div>)
    )
  }

  getPageRows = (array, pageNumber, pageSize) => {
    const arSlice = array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize)
    this.addPageFillerOptions(arSlice, pageSize)

    return arSlice
  }

  addPageFillerOptions = (array, pageSize) => {
    // Add empty options so pagination stays in the same place when there are fewer options
    const arLengthAtStart = array.length
    let i = 0
    for (i = 0; i < pageSize - arLengthAtStart; i++) {
      array.push('filler_option')
    }

    return array
  }

  ProductCategories = props => {
    const paginationMapItem = props.paginationMap.get(props.paginationMapKey)
    const pageNumber = paginationMapItem.pageNumber
    const pageSize = paginationMapItem.pageSize
    const totalPages = paginationMapItem.totalPages

    const categoriesSlice = this.getPageRows(props.categories, pageNumber, pageSize)
    const categories = categoriesSlice.map((category, index) => {
      return category === 'filler_option'
        ? (
          <span
            className='one-col'
            key={index}
          >
            <div
              className='assistant-mobile-option'
              style={{ color: 'white' }}
            >
              -
            </div>
          </span>
        )
        : (
          <span
            className='one-col' /* "two-col" */
            key={index}
          >
            <div
              className='assistant-mobile-option'
              onClick={() => props.onClick(category)}
              data-tag='track-link'
              data-analytics-text={
                ANALYTICS_LINK_SECTIONS.ASSISTANT + category.category
              }
            >
              {category.category}
            </div>
          </span>
        )
    })

    return (
      <div className='assistant-mobile-content'>
        {_createNav(props.selections, props.onNav)}
        <div className='assistant-mobile-prompt'>
          <b>{`${props.content.static.categorySelection.confirmation} ${props.selection.name}!`}</b>{' '}
          {props.content.static.categorySelection.prompt}
        </div>
        <div className='assistant-mobile-options'>{categories}</div>
        <ListPagination
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalPages={totalPages}
          setPageNumber={this.props.setPaginationMapItemPageNumber}
          paginationMapKey={this.props.paginationMapKey}
        />
      </div>
    )
  }
}

function AssistantRedirect (props) {
  return (
    props.closeAssistant
      ? (
        <Redirect
          to={{
            pathname: props.pathname,
            state: props.state
          }}
        />)
      : (
        <div className='assistant-mobile-content'>
          <div className='assistant-mobile-prompt'>{props.prompt}</div>
          <Redirect
            to={{
              pathname: props.pathname,
              state: props.state
            }}
          />
        </div>)
  )
}

function StaticSelection (props) {
  const permittedOptions = getPermittedOptions(props.static.options, props.permissions, props.userType)
  const col = permittedOptions.length > 5 ? 'two-col' : 'one-col'
  const options = permittedOptions.map((option, index) => (
    <span className={col} key={index}>
      <div
        className='assistant-mobile-option'
        onClick={() => props.onClick(option)}
        data-tag='track-link'
        data-analytics-text={ANALYTICS_LINK_SECTIONS.ASSISTANT + option.value}
      >
        {option.label}
      </div>
    </span>
  ))
  return (
    <div className='assistant-mobile-content'>
      {_createNav(props.selections, props.onNav)}
      <div className='assistant-mobile-prompt'>
        <b>{props.static.confirmation}</b> {props.static.prompt}
      </div>
      <div className='assistant-mobile-options'>{options}</div>
    </div>
  )
}

/* ADVERSE EVENTS PAGE */
function ReportAdverseEvents ({ selections, onNav, languageContent, promptContent }) {
  return (
    <div className='assistant-mobile-content'>
      {_createNav(selections, onNav)}
      <div className='assistant-mobile-prompt' style={{ marginBottom: '0.5rem' }}>
        <strong>{promptContent.adverseEventsConfirmation}</strong>
      </div>
      <div style={{ padding: '0 12px' }}>
        {languageContent.reportAnAdverseEventCall}
        {' '}<a href='tel:8446633742' style={{ whiteSpace: 'nowrap' }}>844-663-3742</a>
        {languageContent.FDAContact}
        {' '}<a href='tel:+18003321088' style={{ whiteSpace: 'nowrap' }}>1-800-FDA-1088 <wbr/>(1-800-332-1088)</a>
        .
      </div>
    </div>
  )
}

/* PRODUCT INFORMATION FLOW */
function ProductSelection (props) {
  const products = props.products.map((product, index) => (
    <button
      className='btn btn-info btn-lg m-2'
      onClick={() => props.onClick(product)}
      data-tag='track-link'
      data-analytics-text={ANALYTICS_LINK_SECTIONS.ASSISTANT + product.name}
      key={index}
      style={{ width: '127px' }}
    >
      {product.name}
    </button>
  ))
  return (
    <div className='assistant-mobile-content'>
      {_createNav(props.selections, props.onNav)}
      <div className='assistant-mobile-prompt'>
        <b>{props.content.static.productSelection.confirmation}</b>{' '}
        {props.content.static.productSelection.prompt}
      </div>
      <br />
      <div className='assistant-mobile-options'>{products}</div>
    </div>
  )
}

function Questions (props) {
  const questions = props.questions[props.currentPage].map(
    (question, index) => (
      <span className='one-col' key={index}>
        <div
          className='assistant-mobile-option question-option'
          data-tag='track-link'
          data-analytics-text={
            ANALYTICS_LINK_SECTIONS.ASSISTANT +
            (question.content
              ? question.content.displayText
              : question.displayText)
          }
          onClick={() => props.onClick(question)}
        >
          {question.displayText}
        </div>
      </span>
    )
  )
  const displayName = props.selection.category
    ? props.selection.category
    : props.selection.displayText

  // create pagination bar
  const isFirstPage = props.currentPage === 0
  const isLastPage = props.currentPage === props.questions.length - 1
  let pageNav = null
  if (props.questions.length > 1) {
    pageNav = props.questions.map((_value, index) => {
      return index === props.currentPage ? (
        <span className='pageNavCenter' key={index}>
          <b className='centerCurrent'>{index + 1}</b>
        </span>
      ) : (
        <span className='pageNavCenter' key={index}>
          <span
            className='centerContent'
            onClick={() => props.onPageNav(index)}
          >
            {index + 1}
          </span>
        </span>
      )
    })

    pageNav.unshift(
      <span className='pageNavLeft' key='left'>
        {!isFirstPage ? (
          <span className='leftContent' onClick={props.onPageBackward}>
            {'<'}
          </span>
        ) : (
          <span className='arrowDisabled'>{'<'}</span>
        )}
      </span>
    )

    pageNav.push(
      <span className='pageNavRight' key='right'>
        {!isLastPage ? (
          <span className='rightContent' onClick={props.onPageForward}>
            {'>'}
          </span>
        ) : (
          <span className='arrowDisabled'>{'>'}</span>
        )}
      </span>
    )
  }
  return (
    <div className='assistant-mobile-content'>
      {_createNav(props.selections, props.onNav)}
      <div className='assistant-mobile-prompt'>
        <b>{`${props.content.static.questionsConfirmation} ${displayName}.`}</b>{' '}
        {props.content.static.questionsPrompt}
      </div>
      <div className='assistant-mobile-options'>
        {questions}
        {isLastPage ? (
          <span className='one-col'>
            <span
              className='assistant-mobile-option question-option none'
              data-tag='track-link'
              data-analytics-text={
                ANALYTICS_LINK_SECTIONS.ASSISTANT +
                props.content.static.noneHelpful
              }
              onClick={() => props.onClick({ deadend: true })}
            >
              {props.content.static.noneHelpful}
            </span>
          </span>
        ) : null}
      </div>
      <div className='pageNav'>{pageNav}</div>
    </div>
  )
}

function Answer (props) {
  let content
  switch (props.selection.content.contentType) {
    case 'TEXT':
      content = (
        <div>
          <div className='assistant-mobile-prompt'>
            <b>{props.content.static.question}</b>
          </div>
          <div className='assistant-mobile-prompt'>{props.selection.displayText}</div>
          <br />
          <div className='assistant-mobile-prompt'>
            <b>{props.content.static.answer}</b>
          </div>
          <div className='assistant-mobile-prompt'>
            {props.selection.content.displayText}
          </div>
        </div>
      )
      break
    case 'LINK':
      content = (
        <div className='assistant-mobile-prompt'>
          {props.content.static.linkBefore}
          <a
            href={props.selection.content.displayText}
            target='_blank'
            rel='noopener noreferrer'
          >
            {props.content.static.link}
          </a>
          {props.content.static.linkAfter}
        </div>
      )
      break
    case 'DOC': {
      const doclink =
        API_BASE_URL +
        'assistant/download?product=' +
        props.selections[2].veevaProductCode +
        '&documentNumber=' +
        props.selection.content.displayText +
        '&country=' +
        StaticConfig.Context.Country.name +
        '&searchUserType=' +
        StaticConfig.Context.UserType
      content = (
        <div className='assistant-mobile-prompt'>
          <a
            href={doclink}
            target='_blank'
            rel='noopener noreferrer'
            data-tag='track-download'
            data-analytics-text={props.selection.content.displayText}
          >
            {props.content.static.docLink}
          </a>
        </div>
      )
      break
    }
    default:
      return <Error />
  }
  return (
    <div className='assistant-mobile-content'>
      {_createNav(props.selections, props.onNav)}
      {content}
    </div>
  )
}

/* ERROR PAGE */
function Error (props) {
  return (
    <div className='error-container'>
      <div className='error-image'>
        <img src={via2} alt='Ami' />
      </div>

      <div className='assistant-mobile-prompt'>
        <b>{props.content.bold}</b> {props.content.message}
        <br /> <br />
        {props.content.suggestion}{' '}
        <Link data-tag='track-link' data-analytics-text='Search' to='/search'>{props.content.link}</Link>
        {props.content.end}
      </div>
    </div>
  )
}

/* NOT USEFUL PAGE */
function Deadend ({ content, permissions }) {
  const search = new Array()
  if (permissions.includes(PERMISSIONS.SEARCH)) {
    search.push(' ')
    search.push(content.link)
    search.push(' ')
    search.push(<Link data-tag='track-link' data-analytics-text='Search' to='/search'>{content.searchLink}</Link>)
  }
  return (
    <div className='error-container'>
      <div className='error-image'>
        <img src={via5} alt='Ami' />
      </div>

      <div className='assistant-mobile-prompt'>
        <b>{content.bold}</b> {content.disclaimer}
        <br />
        <br />
        {content.start}{' '}
        <Link data-tag='track-link' data-analytics-text='Submit Inquiry' to='/submit-inquiry'>{content.inquiryLink}</Link>
        { search }
        {content.confirmation}
      </div>
    </div>
  )
}

function _createNav (selections, handleNav) {
  const nav = [
    <span
      key='Home'
      onClick={() => handleNav()}
      className='assistant-mobile-nav history'
    >
      {'Home'}
    </span>
  ]
  selections.forEach(function (value, index, selections) {
    nav.push(' > ')
    const navClass =
      index === selections.length - 1
        ? 'assistant-mobile-nav'
        : 'assistant-mobile-nav history'
    if (typeof value === 'object') {
      let displayText
      if (value.label) {
        displayText = value.label
      } else if (value.name) {
        displayText = value.name
      } else if (value.content) {
        displayText = 'Answer'
      } else {
        displayText = 'Question'
      }
      nav.push(
        <span key={index} onClick={() => handleNav(index)} className={navClass}>
          {displayText}
        </span>
      )
    } else {
      nav.push(
        <span key={index} onClick={() => handleNav(index)} className={navClass}>
          {value}
        </span>
      )
    }
  })
  return <div className='assistant-mobile-nav-container'>{nav}</div>
}

export default ContentMobile



// WEBPACK FOOTER //
// ./src/mi-app/digitalAssistant/ContentMobile.js